import React, { useState } from 'react';
import styles from './Step4Packages.module.scss';
import PackageCard from '../ui/PackageCard/PackageCard';
import Button from '../ui/Button/Button';
import { trackEvent } from '../../utils/analytics';

const packagesData = [
  {
    id: 'standard',
    title: 'Standard',
    price: '7 000 ₴',
    services: [
      'Підготовка та подача заявки: правильне оформлення всіх документів',
      'Формування класів: підбір МКТП спеціально під вашу діяльність',
      'Супровід у процесі розгляду: контроль та відстеження статусу',
      'Відповіді на формальні запити: безкоштовні прості технічні відповіді',
    ],
    isRecommended: false,
    description: 'Мінімальна ціна та швидкий старт. Без оцінки ризиків.',
  },
  {
    id: 'plus',
    title: 'Plus',
    price: '14 000 ₴',
    services: [
      'Все, що в пакеті "Standard"',
      'Юридичний аналіз ризиків на основі перевірки',
      'Консультування щодо можливих порушень прав клієнта',
      'Захист від відмов: одна відповідь на попередню відмову (включено)',
    ],
    isRecommended: true,
    description: 'Оптимальний баланс ціни та безпеки. Оцінка ризиків включена.',
  },
  {
    id: 'premium',
    title: 'Premium',
    price: '25 000 ₴',
    services: [
      'Все, що в пакетах "Standard" та "Plus"',
      'Повний супровід без обмежень на всіх етапах',
      'Робота зі складними випадками: відповіді без лімітів',
      'Апеляція: оскарження рішення в Апеляційній палаті',
      '🔥 ГАРАНТІЯ ПОВЕРНЕННЯ КОШТІВ у разі остаточної відмови',
    ],
    isRecommended: false,
    description: 'Максимальний захист. Повний All-Inclusive та гарантія повернення.',
  },
];

const Step4Packages = ({ onNextStep, onShowComparison }) => {
  const [selectedPackage, setSelectedPackage] = useState(null);

  const handleSelectPackage = (packageId) => {
    setSelectedPackage(packageId);
  };

  const handleNext = () => {
    trackEvent('add_to_cart', {
      currency: 'UAH',
      items: [
        {
          item_id: selectedPackage,
          item_name: selectedPackage
        }
      ]
    });
    onNextStep({ package_type: selectedPackage });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <p className={styles.subtitle}>Визначте рівень супроводу та гарантій для вашої заявки.</p>
      </div>
      <div className={styles.cardsContainer}>
        {packagesData.map((pkg) => (
          <PackageCard
            key={pkg.id}
            {...pkg}
            isSelected={selectedPackage === pkg.id}
            onSelect={() => handleSelectPackage(pkg.id)}
            onShowComparison={onShowComparison}
          />
        ))}
      </div>
      <div className={styles.buttonWrapper}>
        <Button
          variant="primary"
          onClick={handleNext}
          disabled={!selectedPackage}
        >
          Продовжити
        </Button>
      </div>
    </div>
  );
};

export default Step4Packages;
